import { render, staticRenderFns } from "./MarketStrikers.vue?vue&type=template&id=62aa9f32"
import script from "./MarketStrikers.vue?vue&type=script&lang=js"
export * from "./MarketStrikers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports